<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import Transcription from './Transcription.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <div class="grid gap-2">
      <AudioChip
        :attachment="attachment"
        class="p-2 text-n-slate-12 skip-context-menu"
      />
      <Transcription :attachment="attachment" />
    </div>
  </BaseBubble>
</template>
